import React from 'react';
import { DataTable, useListContext } from 'react-admin';

import { DatagridSkeleton } from './Datagrid';


const CustomDataTable = ({ children, ...props }) => {
    const { isLoading } = useListContext();

    if (isLoading) {
        const columnCount = Array.isArray(children) ? children.length : 1;
        return <DatagridSkeleton columns={columnCount} rows={5} />;
    }

    return (
        <DataTable {...props}>{children}</DataTable>
    );
};

CustomDataTable.Col = DataTable.Col;

export default CustomDataTable;